import { graphql } from "../gql";

export const getClaimsQueryDoc = graphql(`
  query getClaims {
    claims {
      __typename
      id
      icn
      itemizedBillLines {
        __typename
        alaRowId
        dateOfService
        description
        groupCode
        id
        itemNumber
        lineNumber
        procedureCode
        procedureCodeModifier
        revCode
        s3InputSourceId
        totalCharge
        units
        versionFingerprint
      }
    }
  }
`);
